export const API_URL =
    process.env.REACT_APP_API_URL || 'http://localhost:8344/api'

export const VAPID_PUBLIC_KEY =
    process.env.REACT_APPVAPID_PUBLIC_KEY ||
    'BEeEEbgFRmQFKCBXqK3fJVco9Aj_Z00r1RrQkuUkmk_z5AwS1I5FwUUoBWou9hOdDDiko_Ah8MKLy_TA4tjK3UM'
